<template>
  <v-autocomplete
    :disabled="disabled || internalLoading"
    :hide-details="hideDetails"
    :items="allOperations"
    :loading="loading || internalLoading"
    :value="value"
    class="select"
    item-text="name"
    return-object
    label="Tätigkeit"
    overflow
    @input="onInput"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { api, endpoints } from '@/api'

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    project: {
      type: Object,
      default: null,
    },
    hideDetails: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      internalLoading: false,
      allOperations: [],
    }
  },
  computed: {
    ...mapGetters(['selectedTenant', 'selectedTenantObj']),
  },
  watch: {
    project () {
      this.get()
    },
    selectedTenant () {
      this.get()
    },
  },
  mounted () {
    this.get()
  },
  methods: {
    async get () {
      this.internalLoading = true
      if (this.selectedTenant === null) {
        return
      }
      try {
        const filters = {
          tenant: this.selectedTenant,
        }
        let ignore_assignment = this.selectedTenantObj && this.selectedTenantObj.ignore_project_operation_assignment
        if (this.project !== null && !ignore_assignment) {
          filters.projects = this.project.id
        }
        const r = await api(endpoints.fetch_operation(), filters, {method: 'GET'})
        if (r.ok) {
          this.allOperations.splice(0, this.allOperations.length, ...await r.json())
        } else {
          // TODO: error handling
        }
      } catch (err) {
        // TODO: error handling
      } finally {
        this.internalLoading = false
      }
    },
    onInput (data) {
      this.$emit('input', data)
    }
  }
}
</script>
